<header>
  <div class="layout-row">
    <!-- Logo -->
    <a class="BO9-logo" (click)="mobile = false" routerLink='/profile/Edit'>BO9</a>


    <nav class="layout-row" [ngClass]="{ 'show-nav': mobile }">
    </nav>
  </div>
</header>

<!-- Overlay for mobile menu -->
@if (mobile) {
  <div class="menu-overlay" (click)="mobile = false"></div>
}
